import { z } from 'zod';
import { optionalImageUrlSchema } from './lesson';

const targetSkillSchema = z.object({
  name: z.string().min(1, 'Skill name is required').max(255, 'Name too long'),
  description: z.string().max(500).optional(),
});

export const programFormSchema = z.object({
  name: z.string().min(1, 'Program name is required').max(255, 'Name too long'),
  academySportId: z.string().uuid().optional(),
  description: z.string().optional(),
  skillLevel: z.enum(['any', 'beginner', 'intermediate', 'advanced']).optional(),
  ageGroupId: z.union([z.string().uuid(), z.literal('')]).optional().nullable(),
  targetSkills: z.array(targetSkillSchema).default([]),
  goals: z.string().max(5000).optional(),
  isActive: z.boolean().default(true),
  isInvitationOnly: z.boolean().default(false),
  previousProgramId: z.union([z.string().uuid(), z.literal('')]).optional().nullable(),
  imageUrl: optionalImageUrlSchema,
});

export type ProgramFormData = z.infer<typeof programFormSchema>;

/** Update skill progress for a student (coach dashboard) */
export const studentProgramSkillUpdateSchema = z.object({
  skillName: z.string().min(1).max(255),
  completed: z.boolean(),
  notes: z.string().max(2000).optional(),
});

export type StudentProgramSkillUpdateData = z.infer<typeof studentProgramSkillUpdateSchema>;

export const markProgramCompleteBodySchema = z.object({
  academyId: z.string().uuid(),
});

export type MarkProgramCompleteBody = z.infer<typeof markProgramCompleteBodySchema>;

export const markCertificateIssuedBodySchema = z.object({
  academyId: z.string().uuid(),
});

export type MarkCertificateIssuedBody = z.infer<typeof markCertificateIssuedBodySchema>;
